import React from 'react'

function CreateBand() {
  return (
    <div>CreateBand</div>
  )
}

export default CreateBand